export default {
    categories: {
        DOCUMENTATION: 'Documentación',
        CASE: 'Caso',
        ACCOUNT: 'Cuenta',
        OPERATION: 'Operación',
        OTHERS: 'Otros',
        OPERATION_OTHERS: 'Otros'
    },
    subcategories: {
        ACREDITACION_CAMBIO_DIRECCION_FISCAL: 'Acreditación de cambio de dirección fiscal',
        ALTA_DE_CLIENTE_FI: 'Alta de cliente FI',
        ALTA_DE_CLIENTE: 'Alta de cliente',
        ALTA_CLIENTE: 'Alta de cliente',
        ALTA_REPRESENTANTES_Y_O_AUTORIZADOS: 'Alta representantes y/o autorizados',
        ALTA_TUTOR_REPRESENTANTE_AUTORIZADO: 'Alta tutor, representante o autorizado',
        ANEXO_AL_DFI: 'Anexo al DFI',
        APODERAMIENTO_SENTENCIA_JUDICIAL: 'Apoderamiento /sentencia judicial',
        APORTANTE_PP: 'Aportante PP',
        ARTICLES_OF_ASSOCIATION: 'Articles of association',
        AUTORIZACION_A_TERCEROS: 'Autorización a terceros',
        BOLETIN_ADHESION_FP: 'Boletín adhesión FP',
        CAMBIO_DE_COMERCIALIZADOR: 'Cambio de comercializador',
        CARTULINA_DE_FIRMAS_APODERAMIENTO: 'Cartulina de firmas apoderamiento, representantes/apoderados (legales) En el caso de entidades financieras, cartulian de firmas de los apoderados (ver persona física)',
        CERTIFICADO_CIUDADANO_UE: 'Certificado de registro de ciudadanos de la UE',
        CERTIFICADO_SECRETARIO_CONSEJO_ADMINISTRACION: 'Certificado secretario consejo administración',
        CLAUSULADO_ALTA_DE_CLIENTE: 'Clausulado Alta de cliente',
        CLAUSULADO_BOLETÍN_ADHESIÓN_FP: 'Clausulado Boletín adhesión FP',
        CLAUSULADO_ORDEN_DE_SUSCRIPCION: 'Clausulado Orden de suscripción-es',
        CLAUSULADO_ORDEN_DE_SUSCRIPCION_TRASPASO_FI: 'Clausulado Orden de suscripción-es traspaso-s FI',
        CONSTITUCION_Y_ESTATOS: 'Escritura de constitución y estatutos vigentes',
        CUESTIONARIO_CONOCIMIENTO_PERSONA_FISICA: 'Cuestionario de Conocimiento Persona Física',
        CUESTIONARIO_CONOCIMIENTO_PERSONA_JURIDICA: 'Cuestionario de Conocimiento Persona Jurídica',
        DECLARACION_FATCA_CRS_SOCIEDAD: 'Declaración FACTA y CRS de la Sociedad',
        DECLARACION_FATCA_CRS_AEAT: 'Declaración FACTA y CRS',
        DFI: 'DFI (actualizado de oficio)',
        DFP: 'DFP (actualizado)',
        DOCUMENTO_ACREDITATIVO_TITULARIDAD_CC: 'Documento acreditativo titularidad cuenta corriente',
        DOCUMENTO_IDENTIFICATIVO_PF_ANVERSO: 'Documento identificativo (Anverso).',
        DOCUMENTO_IDENTIFICATIVO_PF_REVERSO: 'Documento identificativo (Reverso).',
        DOCUMENTO_IDENTIFICATIVO_PJ: 'Documento identificativo.',
        DOCUMENTOS_FATCA_CRS_AEAT: 'Documentos Fatca, CRS, AEAT',
        EEPP: 'EEPP (traspasos)',
        ESCRITURA_CONSTITUCION: 'Escritura de constitución',
        ESCRITURA_O_ACTA_DE_CONSTITUCION: 'Escritura o acta de constitución',
        ESCRITURAS_DE_PODERES: 'Escrituras de poderes de los representantes firmantes',
        ESPANOL_NO_RESIDENTE: 'Español No residente. Certificado de residencia fiscal o Consulado (reembolsos)',
        ESTATUTOS_VIGENTES: 'Estatutos vigentes',
        ESTRUCTURA_ACCIONARIAL: 'Estructura Accionarial',
        EVALUACION_CONVENIENCIA: 'Evaluación conveniencia',
        EXTRANJERO_NO_RESIDENTE: 'Extranjero no residente, certificación negativa de residencia en España (reembolsos)',
        IDENTIFICACION_ESTRUCTURA_DE_PROPIEDAD_Y_CONTROL: 'Todas las sociedades y SICAV, excepto BOCOTizadas. Identificación estructura de propiedad y control (25% acciones) persona física final, en caso de no existir, administrador-es.',
        INFORME_SEMESTRAL: 'Informe Semestral (actualizado en fecha publicación CNMV)',
        LIBRO_DE_FAMILIA: 'Fotocopia Libro de familia',
        MODELO_KYC: 'Estructura accionarial (modelo KYC)',
        OPERATION_OTHERS: 'Otros',
        OPERATION_TICKET: 'Boleta',
        ORDEN_DE_SUSCRIPCION: 'Orden de suscripción-es',
        ORDEN_DE_SUSCRIPCIONS_TRASPASO_FI: 'Orden de suscripción-es traspaso-s FI',
        SOLICITUD_DE_APORTACION_FP: 'Solicitud de aportación FP',
        SOLICITUD_DE_TRASLADO_DC_DE_FP: 'Solicitud de traslado DC DE FP',
        TEST_DE_CONVENIENCIA: 'Test de conveniencia',
        SUPPORTING_DOCUMENT: 'Documentos de ayuda',
        OTHERS: 'Otros',
        NO_INNOCAPITAL_RAW_DOCUMENTATION: 'Documentación escaneada sin clasificar',
        DOCUMENTACION_ACREDITATIVA_APORTANTE_CONYUGE: 'Documentación acreditativa aportante conyuge',
        DOCUMENTACION_ACREDITATIVA_APORTANTE_DISCAPACITADO: 'Documentación acreditativa aportante discapacitado',
        VIDEOIDENTIFICACION: 'Prueba de videoidentificación',
        VIDEO_IDENTIFICATIVO_PF_ANVERSO: 'Vídeo documento identificativo (Anverso)',
        VIDEO_IDENTIFICATIVO_PF_REVERSO: 'Vídeo documento identificativo (Reverso)',
        DOCUMENTO_AUTORIZACION_ACCESO_INFORMACION: 'Documento de autorización de acceso a información',
        FINAMETRIX: 'Documentación escaneada',
        DOCUMENTACION_ACREDITATIVA_DISCAPACIDAD: 'Certificado Discapacidad',
        OPERATION_RECEIPT: 'Justificante de operación',
        TEST_KYC_ASOCIADO_PATRONO: 'Cuestionario de Conocimiento Asociado/Patrono',
        CONSENTIMIENTO_INVERSOR: 'Consentimiento del inversor',
        SOLICITUD_INVERSION: 'Solicitud de inversión',
        JUSTIFICANTE_INVERSOR_PROFESIONAL: 'Justificante inversor profesional',
        CLASIFICACION_CLIENTE: 'Clasificación cliente',
        TEST_CATEGORIZACION_INVERSOR: 'Test categorización inversor',
        TEST_KYC: 'Test de conocimiento'
    }
};
